import React from "react";
import About_the_Programme from "../assets/images/About_the_Programme.webp";

const AboutComponent = () => {
  return (
    <>
      <section className="AboutProgramme paddingTopBottom" id="scrollAboutProg">
        <div className="container">
          <div className="row">
            <div className="col-md-12  m-auto">
              <div className="row">
                <div className="col-lg-6">
                  <div className="aboutProcontent">
                    <h2 className="title">About the programme</h2>
                    <div className="aboutProcontentdetail">
                      <p className="mob-mar0">
                        The ICICI Bank Aspire Programme nurtures young
                        professionals with "Seva Bhav" - values of humility,
                        adaptability, and a strong willingness to learn. Focused
                        on relationship management, it emphasizes empathy,
                        professionalism, and providing 360-degree banking
                        solutions to customers. The Programme includes extensive
                        residential training, followed by nationwide placements
                        in relationship management (sales) roles. The Aspire
                        Programme will prepare selected applicants for
                        Relationship Manager (RM) job, which is a sales role.
                        This role will involve client interactions and will
                        require travel within and around the assigned
                        location/city. Selected applicants shall be placed in
                        any location based on the requirements of the Bank and
                        will undergo a rigorous training by ICICI Bank.{" "}
                        <b>Read more about the Programme below!</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-8">
                  <div className="AboutProgrammeImg">
                    <img
                      src={About_the_Programme}
                      alt="About ICICI Careers Probationary Officer programme"
                      width="546px"
                      height="302px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutComponent;
